<template>
  <div class="simple-boolean flex flex-col gap-1">
    <label :for="id" class="flex items-center gap-2 text-sm font-medium text-gray-700">
      <input
        :id="id"
        v-capture-input-name="name"
        :name="name"
        type="checkbox"
        :checked="model ?? false"
        :required="required"
        :disabled="disabled"
        class="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 disabled:cursor-not-allowed disabled:opacity-50"
        @change="onChange"
      />

      <span v-if="label">{{ label }}</span>
      <span v-else class="text-sm text-gray-600">{{ model ? 'Activé' : 'Désactivé' }}</span>

      <span v-if="required" class="text-red-600" aria-hidden="true"> * </span>
    </label>
  </div>
</template>

<script setup lang="ts">
import type { BooleanComponentProps } from '@shared/common/form/application/component/boolean/BooleanComponent.types';
import { toRefs } from 'vue';

const model = defineModel<boolean>({ required: true });

const props = defineProps<BooleanComponentProps>();
const emit = defineEmits<{
  change: [value: boolean];
}>();

const { id, name, label, required, disabled } = toRefs(props);

const onChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const value = target.checked;

  model.value = value;
  emit('change', value);
};
</script>
